<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="priceFormGroup">
    <mat-form-field>
      <mat-label>Coding Schema Type</mat-label>
      <mat-select required [formControl]="codingSchemaTypeFormControl" (selectionChange)="onInputChangedSearchCodingSchema($event)">
        <mat-option *ngFor="let type of codingSchemaTypes" [value]="type.name">
          {{type.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Coding Schema Type')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Coding Schema</mat-label>
      <input required matInput type="text" [placeholder]="getInfoTooltip('Coding Schema')"
             [formControl]="codingSchemaFormControl" (input)="onInputChangedSearchCodingSchema($event)"
             [matAutocomplete]="codingSchemaAuto" [disabled]="codingSchemaTypeFormControl.value === ''">
      <mat-autocomplete #codingSchemaAuto="matAutocomplete" [panelWidth]="'40vw'">
        <mat-option (onSelectionChange)="codingSchemaSelected($event.source.value)"
                    *ngFor="let codingSchema of filteredCodingSchemas"
                    [value]="getCodingSchemaDisplayString(codingSchema)" class="custom-mat-option">
          {{getCodingSchemaDisplayString(codingSchema)}}
        </mat-option>
      </mat-autocomplete>
      <button (click)="clearCodingSchemaDescription(codingSchemaFormControl)" *ngIf="codingSchemaFormControl.value"
              aria-label="Clear" mat-button mat-icon-button matSuffix>
        <mat-icon style="color: grey;">clear</mat-icon>
      </button>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Coding Schema')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Proprietary Code</mat-label>
      <input [formControl]="proprietaryCodeFormControl" type="text" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Proprietary Code')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Proprietary Description</mat-label>
      <input [formControl]="proprietaryDescriptionFormControl" type="text" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Proprietary Description')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Currency</mat-label>
      <mat-select required [formControl]="currencyFormControl">
        <mat-option *ngFor="let currency of currencies" [value]="currency.name">
          {{currency.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Currency')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Gross Amount</mat-label>
      <input required [min]="discountAmountFormControl.value" [formControl]="grossAmountFormControl" mask="separator.2"
             thousandSeparator="," (blur)="onGrossAmountValue()" type="text" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Gross Amount')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Discount Amount</mat-label>
      <input [formControl]="discountAmountFormControl"
             (blur)="onDiscountAmountValue()"
             mask="separator.2" thousandSeparator=","
             [max]="grossAmountFormControl.value" type="text" matInput>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Discount Amount')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Start Date</mat-label>
      <input required [formControl]="startDateFormControl" [max]="endDateFormControl.value"
             [matDatepicker]="priceStartDatePicker" matInput>
      <mat-datepicker-toggle [for]="priceStartDatePicker" matIconSuffix>
      </mat-datepicker-toggle>
      <mat-datepicker #priceStartDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Start Date')" class="info-icon">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>End Date</mat-label>
      <input [formControl]="endDateFormControl" [min]="startDateFormControl.value"
             [matDatepicker]="priceEndDatePicker" matInput>
      <mat-datepicker-toggle [for]="priceEndDatePicker" matIconSuffix>
      </mat-datepicker-toggle>
      <mat-datepicker #priceEndDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('End Date')" class="info-icon">help_outline</mat-icon>
  </form>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button (click)="onSaveClick()" color="primary">Save</button>
  <button class="dialog-button" mat-raised-button (click)="onCancelClick()" color="warn">Cancel</button>
</mat-dialog-actions>
